<template>
    <div class="wp">
        <div class="i-1">
            <div class="w-1200 i-1-c">
                <el-row class="h-100" :gutter="15">
                    <el-col class="h-100" :span="12">
                        <div class="tabs">
                            <!-- <p :class="{'p-c':currentTop=='今日头条'}" @click="changeTop('今日头条')">今日头条</p> -->
                            <!-- <p :class="{'p-c':currentTop=='焦点回顾'}" @click="changeTop('焦点回顾')">焦点回顾</p> -->
                                <p class="p1"> 焦点回顾 </p>   
                            <!-- <p :class="{'p-c':currentTop=='企业资讯'}" @click="changeTop('企业资讯')">企业资讯</p> -->
                        </div>
                        <el-carousel indicator-position="none" height="380px">
                            <el-carousel-item v-for="(item,index) in imgs" :key="index" @click.native="getDetail(item.id)">
                             <el-image style="width: 100%; height: 80%" :src="item.fgpic" fit="contain">
                             <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                    </div> -->
                            </el-image>
                                <p class="img-title">{{item.infoTitle}}</p>
                            </el-carousel-item>
                        </el-carousel>
                    </el-col>
                    <el-col class="h-100" :span="12">
                        <div class="r-b">
                            <div class="title">
                                <p class="p1">
                                信息通知
                                </p>
                                <p class="p2 pointer" @click="getList('信息通知')">
                                    MORE+
                                </p>
                            </div>
                            <p v-for="(item,index) in informationNoticeTop" :key="index" class="p3 pointer p-lv" @click="getDetail(item.id,'信息通知')">
                                {{item.infoTitle}}
                            </p>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="w-1200 home-3">
            <div class="h-3-item">
                <com-news newsTitle='行业新闻' :top="industryTop" :top6="industryTop5" @getList='getList' @getDetail='getDetail'></com-news>
            </div>
            <div class="h-3-item">
                <com-news newsTitle='政策法规' :top="policyTop" :top6="policyTop5" @getList='getList' @getDetail='getDetail'></com-news>
            </div>
        </div>
        <!-- <div class="w-1200 home-4">
            <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t">产品中心</p>
                    <p class="t-m-m" @click="routerToUrl('/productCenter')">MORE +</p>
                </div>
            <com-product v-if="productLoading" :list="productCenterTop" :num=6 title="产品详情" @getDetail="getPCdetail"></com-product>
        </div> -->
        <div class="w-1200 home-4" style="height:350px;">
           <div class="title-more">
                <div class="t-m-blue"></div>
                    <p class="t-m-t">企业中心</p>
                    <p class="t-m-m" @click="routerToUrl('/companyCenter')">MORE +</p>
                </div>
            <div class="b-b">
                <el-row :gutter="10"> 
                    <el-col v-for="(item,index) in tldCenterTop" :key="index" class="m-t-20" :span="8" >
                       <div class="b-b-i" @click="getPCdetail(item.id,'企业详情')">
                            <div class="img">
                                <el-image style="width: 100%; height: 100%" :src="item.pics" fit="contain">
                                    <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                        <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                        </div> -->
                                </el-image>
                                <!-- <img :src="item.pics"> -->
                            </div>
                            <div class="right">
                                <p class="p1">{{item.companyname}}</p>
                                <p class="p2" style="height:30px;">主营</p>
                                <p class="p3" style="height:30px;">{{item.cp}}</p>
                                <p class="p2" style="height:30px;">电话</p>
                                <p class="p3" style="height:30px;">{{item.lxdh}}</p>
                            </div>
                            
                        </div>
                    </el-col>
                </el-row>

            </div>
        </div>
        <div class="w-1200 home-5">
             <div class="h-3-i-up">
                <p class="h-3-i-t">热门关键词</p>
                <div class="triangle"></div>
            </div>
            <p v-for="(item,index) in hotWords" :key="index"  class="p1">{{item}}</p>
        </div>
    </div>
</template>
<script>
import Information from './Information.js';
export default Information;
</script>
<style lang="scss" scoped>
@import './Information.scss';
</style>